module.exports = __webpack_public_path__ + "static/media/Niveau_elN3_4_594593.7936e7c8.png";